import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './PlayerButton.css';

import { DataStore } from '../DataStore';

@observer
class PlayerButton extends Component {
    clickPlayButton = (event) => {
        DataStore.isPlay = !DataStore.isPlay;
    }

    clickPrevButton = (event) => {
        DataStore.count = DataStore.count - 1;
    }

    clickNextButton = (event) => {
        DataStore.count = DataStore.count + 1;
    }

    render() {
        return (
          <div className="player-button">
                <button className="iconfont left-btn icon-previous"
                    onClick={this.clickPrevButton}></button>
                <button className={"iconfont mid-btn " + (DataStore.isPlay ? "icon-play" : "icon-pause")}
                    onClick={this.clickPlayButton}></button>
                <button className="iconfont right-btn icon-next"
                    onClick={this.clickNextButton}></button>
          </div>
        );
    }
}

export default PlayerButton;


// WEBPACK FOOTER //
// ./src/components/PlayerButton.js